import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { Text } from 'atoms';
import { Icon } from './atoms';
import { CloseSvg } from 'components/icons';

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 12px;
    line-height: 24px;
    margin-left: 8px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 20px;
    text-transform: capitalize;
    background: ${displayState?.backgroundColor};
    color: ${displayState?.color};
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Text,
      name: 'Title',
      displayValue: ({ selectedGraph }) => selectedGraph === 'assigned' ? 'Assigned' : selectedGraph,
    },
    {
      component: Icon,
      name: 'Icon',
      displayValue: ({ colors }) => CloseSvg({ width: '15px', height: '15px', color: colors.color })
    }
  ],
})